import reduceReducers from 'reduce-reducers';
import { questionsInitialState } from '@common/feature/questions/store';
import { showQuestionsReducer } from '@common/feature/questions/reducers/show-questions';

const questionsReducer = reduceReducers(
  questionsInitialState,
  showQuestionsReducer,
);

export default questionsReducer;